/**
 * Scriptures for lesson deacon-1 (deacon duties). Text from churchofjesuschrist.org.
 */
import type { Scripture } from './scriptures';

export const deacon1TrainingScripturesEn: Scripture[] = [
  {
    id: 'dc-20-59',
    reference: 'Doctrine and Covenants 20:59',
    text: 'They are, however, to warn, expound, exhort, and teach, and invite all to come unto Christ.',
    verses: [
      {
        verse: 59,
        text: 'They are, however, to warn, expound, exhort, and teach, and invite all to come unto Christ.',
      },
    ],
    context: 'Teachers’ and deacons’ duty to minister through the word and invitation to Christ.',
  },
  {
    id: 'dc-84-111',
    reference: 'Doctrine and Covenants 84:111',
    text: 'And behold, the high priests should travel, and also the elders, and also the lesser priests; but the deacons and teachers should be appointed to watch over the church, to be standing ministers unto the church.',
    verses: [
      {
        verse: 111,
        text: 'And behold, the high priests should travel, and also the elders, and also the lesser priests; but the deacons and teachers should be appointed to watch over the church, to be standing ministers unto the church.',
      },
    ],
    context: 'Deacons and teachers as standing ministers who watch over the church.',
  },
  {
    id: 'dc-107-85-87',
    reference: 'Doctrine and Covenants 107:85–87',
    text:
      'And again, verily I say unto you, the duty of a president over the office of a deacon is to preside over twelve deacons, to sit in council with them, and to teach them their duty, edifying one another, as it is given according to the covenants. And also the duty of the president over the office of the teachers is to preside over twenty-four of the teachers, and to sit in council with them, teaching them the duties of their office, as given in the covenants. Also the duty of the president over the Priesthood of Aaron is to preside over forty-eight priests, and sit in council with them, to teach them the duties of their office, as is given in the covenants—',
    verses: [
      {
        verse: 85,
        text: 'And again, verily I say unto you, the duty of a president over the office of a deacon is to preside over twelve deacons, to sit in council with them, and to teach them their duty, edifying one another, as it is given according to the covenants.',
      },
      {
        verse: 86,
        text: 'And also the duty of the president over the office of the teachers is to preside over twenty-four of the teachers, and to sit in council with them, teaching them the duties of their office, as given in the covenants.',
      },
      {
        verse: 87,
        text: 'Also the duty of the president over the Priesthood of Aaron is to preside over forty-eight priests, and sit in council with them, to teach them the duties of their office, as is given in the covenants—',
      },
    ],
    context: 'Presidencies of deacons, teachers, and the Aaronic Priesthood.',
  },
  {
    id: '1-timothy-3-8-10',
    reference: '1 Timothy 3:8–10',
    text:
      'Likewise must the deacons be grave, not doubletongued, not given to much wine, not greedy of filthy lucre; Holding the mystery of the faith in a pure conscience. And let these also first be proved; then let them use the office of a deacon, being found blameless.',
    verses: [
      {
        verse: 8,
        text: 'Likewise must the deacons be grave, not doubletongued, not given to much wine, not greedy of filthy lucre;',
      },
      {
        verse: 9,
        text: 'Holding the mystery of the faith in a pure conscience.',
      },
      {
        verse: 10,
        text: 'And let these also first be proved; then let them use the office of a deacon, being found blameless.',
      },
    ],
    context: 'Qualifications and proving of deacons.',
  },
];
